<template>
    <div class="card-prestation">
        <div class="form-check" :class="{checked: checked}">
            <span v-if="display_price && price" class="prest-prix">{{price}}{{currency}}</span>
            <input class="form-check-input" v-model="checked" @change="select($event)" type="checkbox" value="" :id="'prestation-'+id">
            <label class="form-check-label" :for="'prestation-'+id">
                <h5>{{title}}</h5>
                <h6 class="descrp-presta">{{text}}</h6>
                <h6 v-if="display_duration && duration">{{duration}} minutes</h6>
                <h6 v-if="enable_count_attendees" class="heading-count">Nombre de participants
                    <span class="counter-container">
                        <button @click="decrease()" :disabled="!checked || this.min_attendees >= this.attendees_nbre">−</button>
                        <input type="text" id="count" class="count" :value="attendees_nbre" readonly>
                        <button @click="increase()" :disabled="!checked || this.max_attendees != null && this.max_attendees <= this.attendees_nbre">+</button>
                    </span>
                </h6>
            </label>
        </div>
    </div>     
</template>

<script>
import { BookingStore } from '../Stores/BookingStore';

export default {
    name: 'CardPrestation',
    props: {
        id: {}, title: {}, text: {},
        display_duration: {}, duration: {}, 
        display_price: {}, price: {}, 
        enable_count_attendees: {}, 
        min_attendees: {type: Number, default: 1},
        max_attendees: {},
        currency: {type: String, default: '€'},
        selected_prestations: [],
        selected: null,
        checked: null,
    },
    emits: ['selected','attendees_nbr'],

    data() {
        return {
            attendees_nbre: 1,
        }
    },

    methods: {
        decrease() {
            // Prevent to decrease if min reached
            if(this.min_attendees >= this.attendees_nbre){
                return;
            }
            this.attendees_nbre--;
            this.$emit('attendees_nbr',this.attendees_nbre);
        },

        increase() {
            // Prevent to increase if max set && max reached
            if(this.max_attendees != null && this.max_attendees <= this.attendees_nbre){
                return;
            }
            this.attendees_nbre++;
            this.$emit('attendees_nbr',this.attendees_nbre);
        },
        select(event){
            event.preventDefault();
            this.$emit('selected',this.checked)
        }
    },
    mounted () {
        console.log("arr is", this.selected_prestations);
        console.log("booking store ->", BookingStore.selected_prestations);
        // this.checked = this.selected
        // console.log("Type:", typeof arr);
        // if (this.selected_prestations.some(obj => obj.id === this.id)) {
        //     this.checked = true
        // }
    }
}
</script>